import React, { useState } from 'react';
import './index.scss';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import Visualis from './Visualis';
import EditionTable from './Table';
import { useIntl } from 'umi';


export default function ChannelsCard(props: any) {
  const {
    segVal,
    tableData = [],
    totalNum = 0,
    barOrPieData = [],
    entityType,
    gameName,
    gameCover,
    totalData,
    tableHeaderOptions,
    cardStatus,
    lineData,
    segementTitle,
    onTableSortChage,
    onTablePagingChange,
    pageSortAttr,
    startDate,
    endDate,
    chartType,
    setChartType,
    firstWeekSinceReleaseDates,

  } = props;

  const { isLoading, isError, isNoData, tableLoading } = cardStatus || {};
  // const [chartType, setChartType] = useState('pie');
  const [chartLoading, setChartLoading] = useState(true);
  const { formatMessage } = useIntl(); // 中英切换方法

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_channels_share` })}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-streaming-channels-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_channels_share` })}
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="channels-card-line">
          <Visualis
            tableData={tableData}
            lineData={lineData}
            segementTitle={segementTitle}
            tableHeaderOptions={tableHeaderOptions}
            chartType={chartType}
            gameName={gameName}
            barOrPieData={barOrPieData}
            segVal={segVal}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            startDate={startDate}
            endDate={endDate}
            firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
          />
        </div>

        <EditionTable
          totalData={totalData}
          tableData={tableData}
          tableHeaderOptions={tableHeaderOptions}
          totalNum={totalNum}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          pageSortAttr={pageSortAttr}
          tableLoading={tableLoading}
          entityType={entityType}
          gameName={gameName}
          gameCover={gameCover}
          startDate={startDate}
          endDate={endDate}
        />
      </CardSlotV2>
    </div>
  );
}
